import { validateGridSearch } from "@/components/composite/data-grid";
import { ProtectedPage } from "@/components/misc/protected";
import { createFileRoute } from "@tanstack/react-router";
import { DraftExperimentsPage } from "./-index/draft-experiments.page";

export const Route = createFileRoute("/draft-experiments/")({
  validateSearch: validateGridSearch,
  component: () => (
    <ProtectedPage requires="org:draft_experiments:read">
      <DraftExperimentsPage />
    </ProtectedPage>
  ),
});
